import { useEffect } from 'react'
import { refreshBillingAfterPayment } from './refreshBilling'
import { useLocation } from '@tanstack/react-router'
import { useSession } from '@/lib/auth-client'
import { toast } from '@/components/ui/toast'
import { useSettingsStore } from '@/stores/useSettingsStore'

/** Handle payment returns once, whether checkout started in a canvas or workspace. */
export function useBillingReturn() {
  const location = useLocation()
  const session = useSession()
  const authenticated = !!session.data?.user
  const openSettings = useSettingsStore((state) => state.open)

  useEffect(() => {
    if (!authenticated) return
    const url = new URL(window.location.href)
    const billing = url.searchParams.get('billing')
    const topUp = url.searchParams.get('topup')
    const card = url.searchParams.get('card')
    if (
      !['success', 'cancel', 'portal'].includes(billing ?? '') &&
      !['success', 'return'].includes(topUp ?? '') &&
      card !== 'added'
    )
      return

    openSettings('billing')
    if (billing === 'cancel') {
      toast('Checkout canceled. No recurring top-up was started.')
    } else if (url.searchParams.get('redirect_status') === 'failed') {
      toast.error('Payment could not be completed. Please try again from Billing.')
    } else if (billing === 'success' || topUp) {
      toast('Payment submitted. Your balance will update once payment is confirmed.')
    }
    refreshBillingAfterPayment()

    for (const key of [
      'billing',
      'topup',
      'card',
      'session_id',
      'payment_intent',
      'payment_intent_client_secret',
      'setup_intent',
      'setup_intent_client_secret',
      'redirect_status',
    ]) {
      url.searchParams.delete(key)
    }
    window.history.replaceState(window.history.state, '', url.toString())
  }, [authenticated, location.href, openSettings])
}
